/*
  Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except
  in compliance with the License. A copy of the License is located at

      http://aws.amazon.com/apache2.0/

  or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Comment } from 'semantic-ui-react';
import { connect } from 'react-redux';

export const LoadingUserComment = props => (
  <Comment
    collapsed={!props.fetchingUser}
  >
    <Comment.Content>
      <Comment.Text>Identifying message sender...</Comment.Text>
    </Comment.Content>
  </Comment>
);


LoadingUserComment.propTypes = {
  fetchingUser: PropTypes.bool.isRequired,
};

export const mapStateToProps = state => ({
  fetchingUser: state.chat.fetchingUser,
});

export default connect(mapStateToProps)(LoadingUserComment);



// WEBPACK FOOTER //
// ./src/components/Chat/LoadingUserComment.js